@if(isHandset)
{
<!-- Mobile Navigation Container -->
<div class="mobile-nav-container" [class.collapsed]="isCollapsed" [class.handset]="isHandset">

    <!-- Mobile Header -->
    @if (!isCollapsed) {
    <div class="mobile-nav-header">
        <div class="mobile-nav-title" (click)="router.navigate(['/'])">
            <img [src]="logoUrl" alt="JJames Smart Parking" class="mobile-nav-brand-logo" />
        </div>
        <button mat-icon-button (click)="toggleCollapse()" class="mobile-close-btn" [attr.aria-label]="'Close navigation'">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    }

    <!-- Mobile Navigation Items -->
    @if (!isCollapsed) {
    <div class="mobile-nav-content">
        <mat-nav-list class="mobile-nav-list">
            @for (item of navigationItems; track item.id) {
            <lib-vertical-menu-mobile-item [item]="item" [isCollapsed]="isCollapsed" [level]="0"
                [isHandset]="isHandset">
            </lib-vertical-menu-mobile-item>
            }
        </mat-nav-list>
    </div>
    }

    <!-- Mobile Footer -->
    @if (!isCollapsed) {
    <div class="mobile-nav-footer">
        <div class="mobile-footer-content">
            <!-- App Version -->
            <div class="mobile-app-version">
                <mat-icon class="mobile-version-icon">info</mat-icon>
                <small>Version 2.0.0</small>
            </div>
        </div>
    </div>
    }
</div>

<!-- Mobile Menu Toggle Button (visible when collapsed) -->
@if (isHandset && isCollapsed) {
<div class="mobile-menu-toggle">
    <button mat-fab color="primary" (click)="toggleCollapse()" class="mobile-toggle-fab">
        <mat-icon>menu</mat-icon>
    </button>
</div>
}

<!-- Mobile Overlay -->
@if (isHandset && !isCollapsed) {
<div class="mobile-overlay" (click)="toggleCollapse()">
</div>
}
}